<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @pageChange="pageChange"
      @searchChange="handleSearchChange"
      tableCardTitle="LIST"
      :RightBtnOptions="{ text: 'Add', isHavePermission: true }"
      @clickClearBtn="handleClickClearBtn"
      @changeTitleActionBtn="visible = true"
    >
      <template v-slot:action="{ tableRow }">
        <a href="javascript:void(0)" @click="handleDownBtn(tableRow.row)">
          <span class="icon-download1" style="color: #333" />
        </a>
      </template>
      <template v-slot:vagueSearch>
        <el-form-item label="Uploaded By">
          <el-select
            v-model="userName"
            style="width: 300px"
            filterable
            remote
            placeholder="please select"
            :loading="uploadedLoading"
            :remote-method="queryName"
            clearable
          >
            <el-option
              v-for="name in nameOptions"
              :key="name.id"
              :label="name.username"
              :value="name.username"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
    </table-view>

    <el-dialog
      title="Add"
      :visible.sync="visible"
      width="446px"
      @close="handleClose"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <el-form ref="form" label-position="top" :model="form" :rules="rules">
          <el-form-item label="File Type" prop="type">
            <el-select v-model="form.type" style="width: 100%">
              <el-option
                v-for="item in fileTypeList"
                :label="item.name"
                :value="item.id"
                :key="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="Customer Type"
            prop="customerType"
            v-if="form.type !== 10"
          >
            <el-select v-model="form.customerType" style="width: 100%">
              <el-option
                v-for="item in customerTypeList"
                :label="item.name"
                :value="item.id"
                :key="item.name"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <el-upload
          ref="upload"
          :action="uploadUrl"
          :headers="{ Authorization: $store.state.token }"
          :data="{ type: form.type, customerType: form.customerType }"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="handleChange"
          :file-list="fileList"
          :on-success="handleUploadSuccess"
        >
          <customize-button style="width: 100%">
            Upload Documents
          </customize-button>
        </el-upload>
        <el-link
          type="primary"
          :underline="false"
          class="download-template-btn"
          @click="handleDownloadTemplateBtn"
        >
          Download Template
        </el-link>
        <ul class="upload-list">
          <li v-for="item in fileList" :key="item.uid">
            {{ item.name }}
          </li>
        </ul>
      </el-card>
      <div slot="footer">
        <customize-button @click="visible = false" style="margin-right: 14px">
          Cancel
        </customize-button>
        <customize-button
          type="primary"
          @click="handleUploadBtn"
          :loading="isLoading"
        >
          Confirm
        </customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTableData,
  download,
  downloadTemplate,
  getUpload,
  getAddlog,
} from './api'
import config from '@/config'
import { ERR_OK } from '@/utils/request'

export default {
  data() {
    const searchModel = [
      {
        label: 'File Name',
        type: 'input',
        key: 'fileName',
      },
      {
        label: 'File Type',
        type: 'select',
        key: 'type',
        selectList: [],
      },
      {
        label: 'Create Time',
        type: 'time',
        key: 'time',
      },
    ]
    const tableModel = [
      {
        label: 'Document Name',
        prop: 'fileName',
      },
      {
        label: 'Document Type',
        prop: 'typeStr',
      },
      {
        label: 'Create Time',
        prop: 'createTime',
      },
      {
        label: 'Uploaded By',
        prop: 'username',
      },
      {
        label: 'Customer Type',
        prop: 'customerTypeStr',
      },
      {
        width: '120',
        label: 'Action',
        slotName: 'action',
      },
    ]
    return {
      nameOptions: [],
      uploadUrl: `${config.baseApi}/customer-api/customer/file/upload`,
      searchModel,
      uploadedLoading: false,
      userName: '',
      tableModel,
      isLoading: false,
      fileTypeList: [
        {
          id: 1,
          name: 'Basic',
        },
        {
          id: 2,
          name: 'Contacts',
        },
        {
          id: 3,
          name: 'Additional Information',
        },
        {
          id: 4,
          name: 'Account Management',
        },
        {
          id: 5,
          name: 'Japan Detail',
        },
        {
          id: 6,
          name: 'Collateral',
        },
        {
          id: 7,
          name: 'Insurance',
        },
        {
          id: 10,
          name: 'CSS AR',
        },
        {
          id: 11,
          name: 'Bank Guarantee',
        },
      ],
      customerTypeList: [
        {
          id: 1,
          name: 'Trade',
        },
        {
          id: 2,
          name: 'Eaas',
        },
        {
          id: 3,
          name: 'Saas',
        },
      ],
      tableData: [],
      pages: {},

      visible: false,
      form: { type: '', customerType: '' },
      rules: {
        type: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        customerType: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
      },
      fileList: [],
    }
  },
  beforeDestroy() {
    this.timer = null
    clearTimeout(this.timer)
  },
  mounted() {
    this.searchModel[1].selectList = this.fileTypeList
    this.initTable()
  },
  methods: {
    handleClickClearBtn() {
      this.userName = ''
      this.nameOptions = []
    },
    handleUploadSuccess({ code, msg }) {
      if (code === ERR_OK) {
        this.$message.success('success')
        this.visible = false
      } else {
        this.$message.error(msg)
        this.fileList.pop()
      }
    },
    queryName(query) {
      this._getUpload(query)
    },
    async _getUpload(query) {
      try {
        this.nameOptions = await getUpload(query)
      } catch (err) {
        console.log(err)
      }
    },
    handleChange(file) {
      if (!file.response) {
        this.fileList.splice(0, 1, file)
      }
    },
    async handleDownloadTemplateBtn() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        downloadTemplate(this.form.type)
      }
    },
    async handleUploadBtn() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        if (this.fileList.length) {
          this.isLoading = true
          this.$refs.upload.submit()
          this.timer = setTimeout(() => {
            this.isLoading = false
            this.initTable()
          }, 1500)
        } else {
          this.$message.warning('Please upload files')
        }
      }
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async handleHrefInfoPage(tableRow) {
      await this.$storage.setItem('customerId', tableRow.id)
      await this.$router.push(
        `/customer-management/${tableRow.id}/info/snapshot`,
      )
      const params = {
        companyId: tableRow.id,
      }
      await getAddlog(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    // 分页器页码改变
    pageChange(params) {
      this._getTableData({ ...params })
    },
    handleSearchChange(params) {
      const _params = Object.assign({}, params, { userName: this.userName })
      _params.current = 1
      this._getTableData(_params)
    },
    async handleDownBtn({ id }) {
      try {
        await download(id)
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
    handleClose() {
      this.fileList = []
      this.$refs.form.resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.el-upload) {
  width: 100%;
}

.download-template-btn {
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: #4458fe;
  line-height: 40px;
  margin-top: 20px;
}

.upload-list {
  width: 100%;

  li {
    width: 100%;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    color: #3a3f63;
    @include no-wrap();

    .remove-btn {
      margin-left: 14px;
    }
  }
}
</style>
